import { render, staticRenderFns } from "./WebPartPricePlanDesigner.vue?vue&type=template&id=42f18b20&scoped=true&"
import script from "./WebPartPricePlanDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartPricePlanDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f18b20",
  null
  
)

export default component.exports